import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianSkillSet } from 'types';

type getTechnicianSkillSetsParams = {
  technicianId?: string;
};

export const getTechnicianSkillSets = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianSkillSetsParams]>): Promise<TechnicianSkillSet[]> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}/skill-sets`);

  return data as TechnicianSkillSet[];
};
